import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Message } from 'src/app/core/class/message';
import { Common } from 'src/app/core/constants/common';
import { CustomerService } from 'src/app/core/services/customer.service';
import { CommonService } from 'src/app/core/services/common.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { ErrorCode } from 'src/app/core/constants/error-code';

@Component({
  selector: 'app-otp-identify',
  templateUrl: './otp-identify.component.html',
  styleUrls: ['./otp-identify.component.scss']
})
export class OtpIdentifyComponent implements OnInit {
  otp: string
  isSubmitConfirmSignOTP: boolean = false;
  success = false;
  isAcceptRequest = true;
  customerDTO: any;
  otpTransactionId: any
  // Refer to form in view
  @ViewChild('f', { static: false }) ngForm: NgForm;
  @ViewChild("inputOtp", { static: false }) inputElement: ElementRef;
  hashLink: string = null;
  // Whether the form change or not
  isFormChanging = false;
  isValid = true;
  show = true;
  otpPattern = Common.OTP_PATTERN
  // Subscribe to form changing
  formChangesSubscription: Subscription;
  subscriptions: Subscription = new Subscription();
  isNotAttestedUser: boolean = false;
  constructor(
    private dialogRef: MatDialogRef<OtpIdentifyComponent>,
    private notificationService: NotificationService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private customerService: CustomerService,
    public commonService: CommonService,
    private message: Message,
    private route: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // disable chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = true;
    // this.document = data; // Kiểm tra loại tài khoản KCT
    this.isNotAttestedUser = this.commonService.checkEnterpriseAnonymusType()
  }

  /**
   * Init component
   */
  ngOnInit() {
    this.customerDTO = this.data.customerDTO;
    this.otpTransactionId = this.data.otpTransactionId;
    this.hashLink = this.data.hashLink;
    this.notificationService.subscribeErrorService();

  }


  /**
   * Destroy component
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * Confirm sign OTP
   */
  async confirmSignOtp() {
    // Nếu đã bấm xác nhận OTP thì retrn, nếu không thì đi tiếp
    if (this.isSubmitConfirmSignOTP) return
    // Flag để check xem đã bấm xác nhận OTP chưa
    this.isSubmitConfirmSignOTP = true;
    const body = {
      hashKey: this.data.hashKey,
      tenantId: this.data.tenantId,
      customerDTO: this.customerDTO,
      otp: this.otp,
      otpTransactionId: this.otpTransactionId
    }
    this.customerService.confirmOtp(body).subscribe(rs => {
      console.log('rs confirmSIgnOTP', rs)
      if (!rs.success) {
        this.toastr.error(rs.message);
        if (rs.code === ErrorCode.Identify) {
          this.dialogRef.close()
          if (this.hashLink) {
            this.route.navigate([`sign-anonymous/${this.data.hashKey}/${this.data.tenantId}/${this.hashLink}/detail`]);
          } else {
            this.route.navigate([`sign-anonymous/${this.data.hashKey}/${this.data.tenantId}/detail`]);
          }
        }
        this.isSubmitConfirmSignOTP = false;
      } else {
        if (!this.isNotAttestedUser) {
          this.toastr.success(this.message.getMessage('messages.identify_otp_success'));
        } else {
          this.toastr.success(this.message.getMessage('messages.identify_otp_success_verify_subject'));
        }
        this.dialogRef.close()
        window.scrollTo(0, 0)
        if (this.hashLink) {
          this.route.navigate([`sign-anonymous/${this.data.hashKey}/${this.data.tenantId}/${this.hashLink}/detail`]);
        } else {
          this.route.navigate([`sign-anonymous/${this.data.hashKey}/${this.data.tenantId}/detail`]);
        }
        this.isSubmitConfirmSignOTP = false;
      }
      this.isAcceptRequest = true;
      // Bỏ flag
      setTimeout(() => {
        this.isSubmitConfirmSignOTP = false;
      }, 1000);
    });
  }

  /**
   * Send code OTP again
   */
  onSendCodeOTPAgain() {
    // Nếu đã bấm xác nhận OTP thì retrn, nếu không thì đi tiếp
    // if (this.isSubmitConfirmSignOTP) return
    if (!this.isAcceptRequest) {
      return
    }
    this.isAcceptRequest = false;
    // this.countDown();

    if (!this.data.anonymousOtp) {
      const body = {
        hashKey: this.data.hashKey,
        tenantId: this.data.tenantId,
        phoneNumber: this.customerDTO.phone
      }

      this.customerService.generateOtp(body).subscribe(rs => {
        if (!rs.success) {
          this.toastr.error(rs.message);
          if (rs.code === ErrorCode.RefusedIdentify) {
            this.dialogRef.close()
            if (this.hashLink) {
              this.route.navigate([`sign-anonymous/${this.data.hashKey}/${this.data.tenantId}/${this.hashLink}/detail`]);
            } else {
              this.route.navigate([`sign-anonymous/${this.data.hashKey}/${this.data.tenantId}/detail`]);
            }
          }
        } else {
          this.otpTransactionId = rs.data;
          this.toastr.success(this.message.getMessage('messages.send_code_otp_again'));
        }
      });
       // Bỏ flag
       setTimeout(() => {
        this.isAcceptRequest = true;
      }, 1000);
    }
  }

  /**
   * Close dialog
   */
  onNoClick() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.show = false;
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    const tenantId = localStorage.getItem('tenantId');
    if ((this.ngForm.dirty && this.show && tenantId != null)
      || (this.show && tenantId != null)) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      // return dialogRe.afterClosed().pipe(map(result => {
      //   if (result) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // }), first());
    } else {
      return true;
    }
  }

  focusInput() {
    if (this.inputElement.nativeElement) {
      this.inputElement.nativeElement.focus();
    }
  }

  /**
   * Init after view comp
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.focusInput();
    }, 300);
  }

  focusOut() {
    this.otp = this.otp ? this.otp.trim() : '';
    if (this.otp.length !== 4) {
      this.isValid = false
    }
  }

  focusIn() {
    this.otp = this.otp ? this.otp.trim() : '';
    if (this.otp.length === 4) {
      this.isValid = true
    }
  }


}
